
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/signup",
      function () {
        return require("private-next-pages/accounts/signup/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/signup"])
      });
    }
  